import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './TeamModals.scss';

type AddUserPayload = {
    email: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
};

type Props = {
    open: boolean;
    onClose: () => void;
    onSubmit: (data: AddUserPayload) => Promise<void>;
};

const AddUserModal: React.FC<Props> = ({ open, onClose, onSubmit }) => {
    const { t } = useTranslation();

    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [loading, setLoading] = useState(false);

    if (!open) return null;

    const submit = async () => {
        if (!email.trim()) return;

        setLoading(true);
        try {
            await onSubmit({
                email: email.trim(),
                firstName: firstName.trim() || undefined,
                lastName: lastName.trim() || undefined,
                phoneNumber: phoneNumber.trim() || undefined,
            });

            setEmail('');
            setFirstName('');
            setLastName('');
            setPhoneNumber('');
            onClose();
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modalOverlay">
            <div className="modal">
                <h2>{t('pages.team.addUser.title')}</h2>

                <label>
                    {t('pages.team.addUser.email')}
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder={t('pages.team.addUser.emailPlaceholder')}
                        required
                    />
                </label>

                <label>
                    {t('pages.team.addUser.firstName')}
                    <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                </label>

                <label>
                    {t('pages.team.addUser.lastName')}
                    <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                </label>

                <label>
                    {t('pages.team.addUser.phone')}
                    <input type="tel" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
                </label>

                <div className="modalActions">
                    <button className="button button-secondary" onClick={onClose}>
                        {t('pages.common.cancel')}
                    </button>
                    <button className="button button-ready" onClick={submit} disabled={loading}>
                        {t('pages.common.add')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddUserModal;
